import { styled } from '@openeducation/oe-rn-themes';
import React, { useState } from 'react';

import { OETextInput } from '../../atoms';
import FormFooter from '../../molecules/form-footer/form-footer';
import { mt } from '../../style-utils';

export interface ChangePasswordFormProps {
  accountName?: string | null;
  labels: {
    currentPasswordLabel: string;
    newPasswordLabel: string;
    confirmPasswordLabel: string;
    buttonSubmit: string;
  };
  errorMessage?: string;
  isLoading?: boolean;
  onSubmit: (data: { password: string; currentPassword: string }) => void;
  onResetValidation?: () => void;
}

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  labels,
  errorMessage,
  isLoading = false,
  onSubmit,
  onResetValidation,
}) => {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
    currentPassword: '',
  });

  const handleFieldChange = (value: string, name?: string) => {
    onResetValidation?.();
    if (name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const { newPassword, confirmPassword, currentPassword } = formData;

  const disableSubmit =
    !currentPassword || !newPassword || confirmPassword !== newPassword;

  return (
    <>
      <OETextInput
        label={labels.currentPasswordLabel}
        autoComplete="password"
        textContentType="password"
        name="currentPassword"
        onChangeText={handleFieldChange}
        value={currentPassword}
        style={mt(12)}
        secure
      />
      <Line />
      <OETextInput
        label={labels.newPasswordLabel}
        autoComplete="password"
        textContentType="password"
        name="newPassword"
        onChangeText={handleFieldChange}
        value={newPassword}
        style={mt(12)}
        secure
      />
      <OETextInput
        label={labels.confirmPasswordLabel}
        autoComplete="password"
        textContentType="password"
        name="confirmPassword"
        onChangeText={handleFieldChange}
        value={confirmPassword}
        style={mt(12)}
        secure
      />
      <FormFooter
        buttonSubmit={{
          onPress: () =>
            onSubmit({
              password: newPassword,
              currentPassword,
            }),
          loading: isLoading,
          label: labels.buttonSubmit,
          disabled: disableSubmit,
        }}
        error={errorMessage}
      />
    </>
  );
};

export default ChangePasswordForm;

const Line = styled.View`
  height: 2px;
  background: ${({ theme }) => theme.color.border};
  margin: 18px 0 0;
`;
